import { createContext } from 'react';

import type { IAppPreviewState } from './AppPreviewState';
import { initialAppPreviewState } from './AppPreviewState';

export type IAppPreviewStateContextValue = IAppPreviewState;

export const AppPreviewStateContext =
  createContext<IAppPreviewStateContextValue>(initialAppPreviewState);
